import { createSelector } from "@ngrx/store";
import { selectApplicationStore } from "../application.selectors";

// **************************************************************************
// AUTHENTICATION SELECTORS (uses parent store)
// **************************************************************************
export const selectAuthenticationState = createSelector(selectApplicationStore, state => state.authentication);
export const selectIsAuthenticated = createSelector(selectAuthenticationState, state => state.isAuthenticated);
export const selectAuthenticationError = createSelector(selectAuthenticationState, state => state.error);
export const selectAuthenticationLoading = createSelector(selectAuthenticationState, state => state.loading);
